import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tab } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useRatings from 'components/Common/Coaches/Hooks/useRatings';

import Pagination from './Pagination';
import Rating from './Rating';

export default function Ratings({ coach }) {
  const rawRatings = useRatings(coach.id);

  if (rawRatings === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="my-5" />
    );
  }

  const ratingsOnPage = 3;
  const groupedRatings = Object.groupBy(rawRatings, (_rating, index) => parseInt(index / ratingsOnPage, 10));

  const eventKey = (page) => `page-${page}`;

  return (
    <Tab.Container id={`coach-${coach.id}-ratings`} defaultActiveKey={eventKey(0)}>
      <Row className="mb-3">
        <Col>
          <h4 className="fw-semibold">Ratings</h4>
        </Col>

        <Col xs="auto">
          <Pagination
            coach={coach}
            ratings={rawRatings}
            pageSize={ratingsOnPage}
            eventKey={eventKey}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <Tab.Content>
            {Object.keys(groupedRatings).map((page) => (
              <Tab.Pane key={eventKey(page)} eventKey={eventKey(page)}>
                {groupedRatings[page].map((rating) => (
                  <Rating key={rating.id} rating={rating} />
                ))}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

Ratings.propTypes = {
  coach: PropTypes.object.isRequired,
};
